import React, {
  Dispatch,
  FC,
  ReactElement,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Button, Card } from 'tea-component';
import { connect } from 'umi';
import _ from 'lodash-es';
import { useMemoizedFn } from 'ahooks';
import Text2SQLtable from './components/Text2SQLtable';
import TransferText2SQL from './components/TransferText2SQL';
import ConfirmModal from './components/ConfirmModal';
import { useModalOpen } from './hoooks/useModal';
import { namespace } from '../../model';
import { useAigcIntl } from '@/pages/aigc/utils/utils';
import { ObjectOfStringValue } from '@/pages/aigc/hooks/useQuery';
import { relevantTableConfig } from './config';
import { useGetTableDetail } from './hoooks';
interface IRelevantProps {
  // 传入一个状态，表格才开始展示
  chatLoading: boolean;
  // 表格需要的请求参数
  currentGame: string;
  // 报错
  chatError: ObjectOfStringValue;
  messages: ObjectOfStringValue;
  dispatch: Dispatch<ReseteAction>;
  [key: string]: unknown;
}
interface ReseteAction {
  type: string;
  payload?: any;
}
export const RelevantTable: FC<IRelevantProps> = ({
  chatLoading,
  currentGame,
  chatError,
  relevantTables,
  messages,
  dispatch,
  ...restProps
}): ReactElement => {
  // 详情
  const {
    runAsync: modalDetailAsync,
    data: detailData = [],
    loading: detailLoading,
    mutate
  } = useGetTableDetail();
  // 删除key
  const refDelKey = useRef<ObjectOfStringValue>({});
  // 拷贝
  const [cloneDeepRelevantTables, setCloneDeepRelevantTables] = useState([]);
  // 中英文
  const { formatMessage, isEn } = useAigcIntl('text2sql');
  // 模态框
  const {
    modalDetailStat,
    modalDelStat,
    modalRelevantStat,
    delclone,
    detailClone,
    detailopen,
    delopen,
    relevantopen,
    relevantclone,
  } = useModalOpen();
  const transferRef = useRef();
  // 失败重试按钮
  const isErrorRetry = useMemoizedFn(() =>
    dispatch({
      type: `${namespace}/rebuildTableOrSql`,
      payload: {
        message: formatMessage('generate_table'),
        isEn,
        isReset: true,
      },
    }),
  );
  // 在详情表格关闭后，先对数据进行置空，防止出现有数据在loading，一闪而过，先让loading出现
  useEffect(() => {
    return () => mutate([]);
  }, [modalDetailStat]);


  useEffect(() => {
    setCloneDeepRelevantTables(relevantTables);
  }, [relevantTables]);

  // 用户操作
  const handleOnClickUserActions = useMemoizedFn(
    <T extends { [key in string]: unknown }>(
      value: T,
      type: 'detail' | 'del',
    ) => {
      refDelKey.current = value;
      if (type === 'del') {
        delopen?.();
      } else {
        detailopen?.();
        const params = {
          game: currentGame?.game_code,
          database: value?.database,
          table: value?.table,
        };
        modalDetailAsync(params);
      }
    },
  );

  // 删除
  const handleOnClickUserActionsDel = useMemoizedFn(() => {
    const newData = cloneDeepRelevantTables?.filter(
      (item) => item.table !== refDelKey.current.table,
    );
    setCloneDeepRelevantTables(newData);
    delclone();
    refDelKey.current = '';
    dispatch({
      type: `${namespace}/updateMessage`,
      payload: {
        relevantTables: _.isEmpty(newData) ? null : newData,
      },
    });
  });

  // 穿梭框确定回调
  const handleOnClickUserActionsTran = useMemoizedFn(() => {
    setCloneDeepRelevantTables(transferRef.current!.dataRes);
    relevantclone();
    dispatch({
      type: `${namespace}/updateMessage`,
      payload: {
        relevantTables: transferRef.current!.dataRes || [],
      },
    });
  });
  return (
    <Card className={'relevant-table-card'}>
      <Card.Body
        title={<>
          {formatMessage('relevant_table')}
          {!_.isEmpty(cloneDeepRelevantTables) && <span className='table_total'>{cloneDeepRelevantTables?.length || 0}  {formatMessage('table_total')}</span>}
        </>}
        operation={
          !_.isEmpty(cloneDeepRelevantTables) && (
            <Button type="link" onClick={relevantopen}>
              {formatMessage('table_edit_relevant')}
            </Button>
          )
        }
      >
        {/* TODO:合并一个表格 */}
        <Text2SQLtable
          {...{
            // loading,
            error: chatError,
            isErrorRetry,
            chatLoading,
            messages,
            tableData: useMemo(
              () =>
                relevantTableConfig(
                  cloneDeepRelevantTables,
                  handleOnClickUserActions,
                  true,
                  formatMessage,
                ),
              [
                cloneDeepRelevantTables,
                handleOnClickUserActions,
                formatMessage,
              ],
            ),
          }}
        />
      </Card.Body>
      <ConfirmModal
        {...{
          visible: modalDetailStat,
          clone: detailClone,
          size: 880,
          isNeedFooter: false,
          caption: refDelKey.current!.table || '',
        }}
      >
        <Text2SQLtable
          {...{
            loading: detailLoading,
            tableData: useMemo(
              () =>
                relevantTableConfig(
                  detailData,
                  handleOnClickUserActions,
                  false,
                  formatMessage,
                ),
              [detailData, formatMessage, handleOnClickUserActions],
            ),
            style: { height: '350px', maxHeight: '230px' },
          }}
        />
      </ConfirmModal>
      <ConfirmModal
        {...{
          visible: modalRelevantStat,
          caption: 'Edit the related tables',
          click: handleOnClickUserActionsTran,
          clone: relevantclone,
          size: 880,
        }}
      >
        <TransferText2SQL
          transferRef={transferRef}
          {...{
            modalRelevantStat,
            cloneDeepRelevantTables,
            game: currentGame?.game_code,
          }}
        />
      </ConfirmModal>
      <ConfirmModal
        {...{
          visible: modalDelStat,
          title: formatMessage('modal_is_ok'),
          desc: formatMessage('modal_main_desc'),
          click: handleOnClickUserActionsDel,
          clone: delclone,
        }}
      />
    </Card>
  );
};
export default connect((state: any) => {
  const { chatLoading, currentGame, chatError, messages, ...restProps } =
		state[namespace];
  return {
    chatLoading,
    currentGame,
    chatError,
    messages,
    ...restProps,
  };
})(RelevantTable);
